"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Pepsi = function Pepsi(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C8.93 0 5.86 1.17 3.517 3.514c-4.688 4.686-4.688 12.284 0 16.971 4.685 4.686 12.284 4.687 16.97 0 4.686-4.687 4.686-12.286-.002-16.97A11.958 11.958 0 0012.001 0zm0 .864c2.506 0 4.817.828 6.678 2.226a23.118 23.118 0 01-15.64 15.52A11.085 11.085 0 01.865 12C.865 5.85 5.85.864 12 .864zm9.342 5.08A11.082 11.082 0 0123.136 12c0 6.15-4.986 11.135-11.136 11.135a11.11 11.11 0 01-8.542-3.994c6.766-2.132 11.665-2.135 15.027-4.611 1.933-1.425 3.205-3.698 3.205-6.283 0-.802-.123-1.575-.348-2.303Z"
  }));
};

Pepsi.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Pepsi.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Pepsi;
exports.default = _default;